import React, {
    useState,
    useEffect
} from 'react';


import {
    useSelector,
    useDispatch
} from 'react-redux';


import ObjetivosNuevos
    from './ObjetivosNuevos';


import {
    modificarObjetivoAction
} from '../../actions/objetivosActions';


import useConfigAuth
    from '../../Hooks/useConfigAuth';


// css
import {

    ContenedorDisponiblesObjetivos,

    EncabezadoDisponibles,
    TituloDisponibles,
    ContenedorNuevoObjetivo,

    AyudaObjetivoNuevo,
    IconoAyudaObjetivo,
    TextoAyudaObjetivo,

    LeyendaDisponibles,
    ItemLeyendaObjetivo,
    PuntoEstadoObjetivo,

    GrillaObjetivosDisponibles,

    TarjetaObjetivoDisponible,
    NombreObjetivoDisponible,

    SinObjetivosDisponibles

} from '../Css/StyledObjetivos';



const ObjetivosDisponibles = (
    props
) => {


    const {
        id,
        seccion
    } = props.seccion;


    const dispatch =
        useDispatch();


    const [
        config
    ] = useConfigAuth();


    const informacionObjetivos =
        useSelector(
            (state) =>
                state.informacion.info_objetivos
        );


    const id_paciente =
        useSelector(
            (state) =>
                state.usuario.id_paciente
        );


    const [
        disable,
        setDisable
    ] = useState(
        false
    );


    const [
        objetivosNuevo,
        setObjetivosNuevo
    ] = useState(
        informacionObjetivos
    );


    const [
        objetivoBD,
        setObjetivoBD
    ] = useState(
        []
    );



    /*
    ====================================
    AGREGAR / QUITAR OBJETIVO
    ====================================
    */

    const cambiarEtapa = (
        id_objetivo,
        custom_objetivo,
        etapa
    ) => {


        if (
            etapa ===
            "2"
        ) {


            const newList =
                JSON.parse(
                    JSON.stringify(
                        objetivosNuevo
                    )
                );


            for (
                let i = 0;
                i < newList.length;
                i++
            ) {


                if (
                    newList[i].id ===
                        id_objetivo &&
                    newList[i].custom ===
                        custom_objetivo
                ) {

                    newList[i]
                        .id_etapa_objetivo =
                            '1';


                    setObjetivoBD(
                        newList[i]
                    );

                }

            }


            setObjetivosNuevo(
                newList
            );


            setDisable(
                true
            );


        } else {


            const newList =
                JSON.parse(
                    JSON.stringify(
                        objetivosNuevo
                    )
                );


            for (
                let i = 0;
                i < newList.length;
                i++
            ) {


                if (
                    newList[i].id ===
                        id_objetivo &&
                    newList[i].custom ===
                        custom_objetivo
                ) {

                    newList[i]
                        .id_etapa_objetivo =
                            '2';


                    setObjetivoBD(
                        newList[i]
                    );

                }

            }


            setObjetivosNuevo(
                newList
            );


            setDisable(
                true
            );

        }

    };



    /*
    ====================================
    GUARDAR CAMBIO
    ====================================
    */

    useEffect(
        () => {


            if (
                objetivoBD.length ===
                0
            ) {

                return;

            }


            const informacion = {

                config,

                payload: {

                    objetivosNuevo,

                    objetivoBD,

                    id_paciente,

                    tipo:
                        "etapa"

                }

            };


            dispatch(
                modificarObjetivoAction(
                    informacion
                )
            );


            setObjetivoBD(
                []
            );


            setTimeout(
                () => {

                    setDisable(
                        false
                    );

                },
                1000
            );


            // eslint-disable-next-line react-hooks/exhaustive-deps
        },
        [
            objetivosNuevo
        ]
    );



    /*
    ====================================
    ACTUALIZAR DESDE REDUX
    ====================================
    */

    useEffect(
        () => {


            setObjetivosNuevo(
                informacionObjetivos
            );


        },
        [
            informacionObjetivos
        ]
    );



    /*
    ====================================
    OBJETIVOS DEL ÁREA
    ====================================
    */

    const objetivosDeSeccion =
        informacionObjetivos.filter(
            objetivo =>

                objetivo
                    .id_seccion_objetivo
                    .toString() ===
                    id.toString()
        );



    return (

        <ContenedorDisponiblesObjetivos>


            {/*
            ====================================
            ENCABEZADO
            ====================================
            */}


            <EncabezadoDisponibles>


                <TituloDisponibles>

                    Disponibles en {
                        seccion
                    }

                </TituloDisponibles>


                <ContenedorNuevoObjetivo>


                    <ObjetivosNuevos

                        seccion={
                            props.seccion
                        }

                    />


                </ContenedorNuevoObjetivo>


            </EncabezadoDisponibles>


            {/*
            ====================================
            AYUDA
            ====================================
            */}


            <AyudaObjetivoNuevo>


                <IconoAyudaObjetivo>

                    i

                </IconoAyudaObjetivo>


                <TextoAyudaObjetivo>

                    <strong>
                        ¿No encontrás el objetivo que buscás?
                    </strong>

                    {' '}

                    Con el botón + podés crear tus propios objetivos.
                    Quedan disponibles para reutilizarlos con otros
                    pacientes.

                </TextoAyudaObjetivo>


            </AyudaObjetivoNuevo>


            {/*
            ====================================
            LEYENDA
            ====================================
            */}


            <LeyendaDisponibles>


                <ItemLeyendaObjetivo>


                    <PuntoEstadoObjetivo
                        agregado={
                            false
                        }
                    />


                    Objetivo no agregado


                </ItemLeyendaObjetivo>


                <ItemLeyendaObjetivo>


                    <PuntoEstadoObjetivo
                        agregado={
                            true
                        }
                    />


                    Objetivo agregado


                </ItemLeyendaObjetivo>


            </LeyendaDisponibles>


            {/*
            ====================================
            OBJETIVOS
            ====================================
            */}


            <GrillaObjetivosDisponibles>


                {
                    objetivosDeSeccion.length ===
                    0
                        ?

                        <SinObjetivosDisponibles>

                            Todavía no hay objetivos disponibles
                            en esta área.

                        </SinObjetivosDisponibles>

                        :

                        objetivosDeSeccion.map(
                            objetivo => {


                                const agregado =
                                    objetivo
                                        .id_etapa_objetivo ===
                                    "2";


                                return (

                                    <TarjetaObjetivoDisponible

                                        key={
                                            `${objetivo.id}-${objetivo.custom}`
                                        }

                                        type="button"

                                        disabled={
                                            disable
                                        }

                                        onClick={
                                            () =>
                                                cambiarEtapa(
                                                    objetivo.id,
                                                    objetivo.custom,
                                                    objetivo.id_etapa_objetivo
                                                )
                                        }

                                    >


                                        <NombreObjetivoDisponible>

                                            {
                                                objetivo.nombre_objetivo
                                            }

                                        </NombreObjetivoDisponible>


                                        <PuntoEstadoObjetivo

                                            agregado={
                                                agregado
                                            }

                                        />


                                    </TarjetaObjetivoDisponible>

                                );

                            }
                        )
                }


            </GrillaObjetivosDisponibles>


        </ContenedorDisponiblesObjetivos>

    );

};


export default ObjetivosDisponibles;